<script>
import DefaultAside from '@/components/common/form-components/DefaultAside'
import Add from '@/components/raf/form-components/Add'

export default {
  mixins: [DefaultAside],
  components: {
    add: Add
  }
}
</script>
